<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row class="mt-xs-1" align="center" justify="center">
          <p class="blue-grey--text">
            Pago procesado de manera segura con:
          </p>
        </v-row>
        <v-row align="center" justify="center">
          <div class="mt-1 px-4">
            <img src="@/assets/mc_sc.svg" alt="mastercard" height="50">
          </div>
          <div class="mt-1 px-4">
            <img src="@/assets/bp.png" alt="bp-logo" height="30">
          </div>
          <div class="mt-1 px-4">
            <img src="@/assets/verified_visa.svg" alt="visa" height="30">
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Footer',
};
</script>
